import styled from "styled-components"

export default styled.main`
  max-width: 750px;
  margin: 0 auto;
  min-height: 100%;
  display: flex;
  flex-direction: column;
`
